import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../marketConnect/layout/MasterLayout'
import ManageCustomers from '../pages/admin-panel/ManageCustomers'
import Report from '../pages/admin-panel/Report'
import PlatformsList from '../pages/platform/PlatformsList'
import ManagePlatform from '../pages/platform/ManagePlatform'
import SuperadminAccountSetting from '../pages/SuperadminAccountSetting'
// import AvailablePlatforms from '../pages/manage-event/AvailablePlatforms'
// import PlatformEvents from '../pages/manage-event/PlatformEvents'
import ManageCustomPlans from '../pages/custom-plans/ManageCustomPlans'
import PricingPlans from '../pages/custom-plans/PricingPlans'
import AddManageUserFunctionality from '../pages/admin-panel/AddManageUserFunctionality'
import ManageRolesFunctionality from '../pages/admin-panel/ManageRolesFunctionality'
import HistoryLogs from '../pages/history-logs/HistoryLogs'
import ManageNewsUpdates from '../pages/admin-panel/news/ManageNewsUpdates'
import AddNewsUpdate from '../pages/admin-panel/news/AddNewsUpdate'
import ManageEmailTemplates from '../pages/admin-panel/email-templates/ManageEmailTemplates'
import { useAppSelector } from 'src/redux/storeHooks'
import UserStaffGuard from './UserStaffGuard'

const SuperAdminRoutes = () => {
  const { fetchedUserAccountData, fetchedUserStaffData } = useAppSelector(state => state.userAccountData)

  const isUserStaff = fetchedUserAccountData?.account_type === 'USER_STAFF'
  const isAllowedDirect = fetchedUserStaffData === null

  return (
    <Routes>
      {/* Default redirect */}
      <Route index element={<Navigate to="/dashboard" />} />

      {/* ======================
          Dashboard (customer_access)
          ====================== */}
      <Route
        path="/dashboard"
        element={
          <UserStaffGuard permissionKey="customer_access">
            <ManageCustomers />
          </UserStaffGuard>
        }
      />

      {!isUserStaff && (
        <>
          {/* ======================
              Reports (report_access)
              ====================== */}
          <Route
            path="/reports"
            element={
              <UserStaffGuard permissionKey="report_access">
                <Report />
              </UserStaffGuard>
            }
          />
          <Route
            path="/reports/:userId"
            element={
              <UserStaffGuard permissionKey="report_access">
                <Report />
              </UserStaffGuard>
            }
          />

          {/* ======================
              User Management (user_access)
              ====================== */}
          {isAllowedDirect && <Route
            path="/manage-user"
            element={
              <UserStaffGuard permissionKey="user_access">
                <AddManageUserFunctionality />
              </UserStaffGuard>
            }
          />}
          {isAllowedDirect && <Route
            path="/manage-roles"
            element={
              <UserStaffGuard permissionKey="user_access">
                <ManageRolesFunctionality />
              </UserStaffGuard>
            }
          />}

          {/* ======================
              Pricing / Plans (manage_plan_access)
              ====================== */}
          <Route
            path="/pricing-plans"
            element={
              <UserStaffGuard permissionKey="manage_plan_access">
                <PricingPlans />
              </UserStaffGuard>
            }
          />
          <Route
            path="/manage-pricing"
            element={
              <UserStaffGuard permissionKey="manage_plan_access">
                <ManageCustomPlans />
              </UserStaffGuard>
            }
          />

          {/* ======================
              Unrestricted admin routes
              ====================== */}
          <Route path="/platforms" element={<PlatformsList />} />
          <Route path="/manage-platform" element={<ManagePlatform />} />
          <Route
            path="/manage-platform/:platformId"
            element={<ManagePlatform />}
          />
          <Route
            path="/account/settings"
            element={<SuperadminAccountSetting />}
          />
          <Route path='/news-updates' element={<ManageNewsUpdates />} />
          <Route path='/news-updates/add' element={<AddNewsUpdate />} />
          <Route path='/email-templates' element={<ManageEmailTemplates />} />
          {/* <Route path="/history/logs" element={<HistoryLogs />} /> */}
        </>
      )}

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/dashboard" />} />
    </Routes>
  )
}

export { SuperAdminRoutes }
